import Photos, { getServerSideProps } from './Photos';
export default Photos;
export { getServerSideProps };
